/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CalculateParams, CurrencyConversionDto } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ApiCurrencyConversionController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-currency-conversion-controller
   * @name Calculate
   * @request GET:/api/v1/currency-conversion
   */
  calculate = (query: CalculateParams, params: RequestParams = {}) =>
    this.http.request<CurrencyConversionDto, any>({
      path: `/v1/currency-conversion`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static calculatePath = '/v1/currency-conversion'
  static calculateMethod = 'GET'
}
